export const companiesConfig = {
    m5: {
      apiKey: process.env.REACT_APP_M5_API_KEY,
      reducerPath: 'm5'
    },
    easyadmin: {
      apiKey: process.env.REACT_APP_EASYADMIN_API_KEY,
      reducerPath: 'easyadmin'
    },
    poulhvidtved: {
      apiKey: process.env.REACT_APP_POULHVIDTVED_API_KEY,
      reducerPath: 'poulhvidtved'
    },
    dansktagkompagni: {
      apiKey: process.env.REACT_APP_DANSKTAGKOMPAGNI_API_KEY,
      reducerPath: 'dansktagkompagni'
    },
    jharder:{
      apiKey: process.env.REACT_APP_JHARDER_API_KEY,
      reducerPath: 'jharder'
    },
    norlivByg: {
      apiKey: process.env.REACT_APP_NORLIVBYG_API_KEY,
      reducerPath: 'norlivByg'
    },
    byensContainer: {
      apiKey: process.env.REACT_APP_BYENSCONTAINER_API_KEY,
      reducerPath: 'byensContainer'
    },
    hyldegårdensByggeEnterprise: {
      apiKey: process.env.REACT_APP_HYLDEGAARDENS_API_KEY,
      reducerPath: 'hyldegårdensByggeEnterprise'
    },
    karlslundeTømrerOgSnedker: {
      apiKey: process.env.REACT_APP_KARLSLUNDE_API_KEY,
      reducerPath: 'karlslundeTømrerOgSnedker'
    },
    m5Gulve: {
      apiKey: process.env.REACT_APP_M5GULVE_API_KEY,
      reducerPath: 'm5Gulve'
    },
    nelcom: {
      apiKey: process.env.REACT_APP_NELCOM_API_KEY,
      reducerPath: 'nelcom'
    },
  };
  